import Section from '../../components/Section';
import { EXPERIENCES } from './data';
import Experience from './Experience';

const SectionExpPage2 = () => (
  <Section>
    {EXPERIENCES.slice(2, 4).map((experience) => (
      <Experience key={experience.company} experience={experience} />
    ))}
  </Section>
);

export default SectionExpPage2;
